module.exports = __webpack_public_path__ + "img/logo_elkatsu.c19928bc.svg";